import script from "./Authority.vue?vue&type=script&setup=true&lang=js"
export * from "./Authority.vue?vue&type=script&setup=true&lang=js"

import "./Authority.vue?vue&type=style&index=0&id=6727cf96&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6727cf96"]])

export default __exports__